import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { authHashRedirect } from "./components/gavion/auth/authHashRedirect";
import { stashInboundRoute } from "./components/gavion/domain/dialer/inboundCall";
import { shouldReloadForStaleChunk } from "./components/gavion/routes/chunkReload";

// After a new deploy, the service worker may replace its pre-cache while
// the page still holds old chunk references. A reload picks up the new
// HTML + new SW cache. A sessionStorage guard prevents infinite loops.
// See https://vite.dev/guide/build.html#load-error-handling
// GAVION: time-based guard, so a tab recovers on every deploy, not just the first (chunkReload.ts).
window.addEventListener("vite:preloadError", () => {
  if (shouldReloadForStaleChunk(sessionStorage, Date.now()))
    window.location.reload();
});

// GAVION: an invite / recovery token fragment becomes the auth-callback route
// before the router starts (see authHashRedirect). replaceState, not a
// navigation: a hash-only change would not reload the page, and the token
// fragment leaves the history entry.
const authCallback = authHashRedirect(window.location);
if (authCallback) window.history.replaceState(null, "", authCallback);

// GAVION inbound calls: keep an « Appel entrant » link (#/appel-entrant?tel=…) across a sign-in (useInboundReturn).
stashInboundRoute(window.sessionStorage, window.location.hash, Date.now());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
